import type { SkillFileNode } from '@onefootprint/request-types/dashboard';
import { readDescription, splitSkillMarkdown } from './skill-markdown';

const getSkillFiles = (
  node: SkillFileNode,
  path: string,
): { node: Extract<SkillFileNode, { kind: 'file' }>; path: string }[] => {
  if (node.kind === 'file') return [{ node, path }];
  return node.children.flatMap((child, index) => getSkillFiles(child, `${path}.${index}`));
};

const getSkillEntry = (node: SkillFileNode, path: string) => {
  const files = getSkillFiles(node, path);
  return (
    files.find(file => file.node.name === 'SKILL.md' && file.path.split('.').length === path.split('.').length + 1) ??
    files[0]
  );
};

const getSkillExcerpt = (node: SkillFileNode, path: string) => {
  const { frontmatter, body } = splitSkillMarkdown(getSkillEntry(node, path)?.node.content ?? '');
  // The agent SDK picks a skill by its frontmatter description, falling back to the first paragraph.
  const description = readDescription(frontmatter);
  const paragraph = body.split(/\n\s*\n/).find(text => text.trim() && !text.trim().startsWith('#')) ?? '';
  return (description || paragraph)
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
    .replace(/[*_`#>]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
};

export { getSkillEntry, getSkillExcerpt, getSkillFiles };
